var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { Project } from '@/models/Project';
import { RolesEnum } from '@/items/Roles';
let Files = class Files extends Vue {
    constructor() {
        // File structure for Typescript files in your Vue project
        // https://tutorials.atabix.com/frontend/typscript_file_structure/
        super(...arguments);
        // #endregion
        // #region @Refs
        // #endregion
        // #region Class properties
        this.files = [];
        this.selectedFile = null;
        this.selectedFileToDelete = null;
        this.isUploading = false;
        this.isLoading = true;
        this.isShowingDialog = false;
        // #endregion
    }
    // #endregion
    // #region Lifecycle Hooks / Init
    mounted() {
        this.fetchFiles();
    }
    // #endregion
    // #region Class methods
    findById(id) {
        return this.files.findIndex((file) => file.id === id);
    }
    onFileChange(event) {
        // if (!event.target.files.length) {
        //   return;
        // }
        // this.selectedFile = event.target.files[0];
        // if (!this.selectedFile) {
        //   return;
        // }
        // this.isUploading = true;
        // new FileModel()
        //   .group(this.group)
        //   .include('author')
        //   .create({ file: this.selectedFile })
        //   .then((file: FileModel) => {
        //     this.files.push(file);
        //     this.selectedFile = null;
        //     this.isUploading = false;
        //   })
        //   .catch((error: AxiosError) => {
        //     ErrorHandler.network(error);
        //     this.selectedFile = null;
        //     this.isUploading = false;
        //   });
    }
    remove(file) {
        if (file.author) {
            this.selectedFileToDelete = file;
            this.$store.dispatch('openDialog', this.dialogOptions);
        }
    }
    // #endregion
    // #region Async methods
    fetchFiles() {
        // new FileModel()
        //   .group(this.group)
        //   .include('author')
        //   .all()
        //   .then((files: FileModel[]) => {
        //     this.files = files;
        //     this.isLoading = false;
        //   })
        //   .catch((error: AxiosError) => {
        //     ErrorHandler.network(error);
        //     this.isLoading = false;
        //   });
    }
    // #endregion
    // #region Getters & Setters
    get dialogOptions() {
        const file = this.selectedFileToDelete;
        return {
            title: this.$t('dialogOptions.confirmation').toString(),
            text: this.$tc('dialogOptions.delete', 1, { item: this.$t('dialogOptions.item.file') }).toString(),
            type: 'warning',
            buttons: {
                confirm: {
                    text: this.$t('dialogOptions.button.delete').toString(),
                    action: () => {
                        if (!file) {
                            return;
                        }
                        // file
                        //   .group(this.group)
                        //   .delete()
                        //   .then(() => {
                        //     if (file.id !== undefined) {
                        //       const index = this.findById(file.id);
                        //       this.files.splice(index, 1);
                        //     }
                        //   })
                        //   .catch((error: AxiosError) => {
                        //     ErrorHandler.network(error);
                        //   });
                    },
                },
                cancel: {
                    text: this.$t('dialogOptions.button.cancel').toString(),
                    action: () => {
                        this.selectedFileToDelete = null;
                    },
                },
            },
        };
    }
    get isAuthorized() {
        return this.$store.state.Auth.hasRole([RolesEnum.ADMIN, RolesEnum.ROOT, RolesEnum.RESELLER, RolesEnum.TEACHER,
        ]);
    }
    // #endregion
    // #region @Watchers
    projectChange(newValue, oldValue) {
        this.fetchFiles();
    }
};
__decorate([
    Prop(),
    __metadata("design:type", typeof (_a = typeof Project !== "undefined" && Project) === "function" ? _a : Object)
], Files.prototype, "project", void 0);
__decorate([
    Watch('project'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], Files.prototype, "projectChange", null);
Files = __decorate([
    Component({
        components: {},
    })
], Files);
export default Files;
